import axios from "axios";
import { toast } from "sonner";

const rawBase = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_URL = rawBase && rawBase !== "undefined" && rawBase !== "null"
  ? rawBase.replace(/\/+$/, "")
  : window.location.origin;

const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("an_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("an_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export default api;

export const fmt = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const openInNewTab = async (getUrl) => {
  const w = window.open("about:blank", "_blank");
  try {
    const url = await getUrl();
    if (!url) { if (w) w.close(); return; }
    if (w) w.location.href = url;
    else window.open(url, "_blank");
  } catch (err) {
    if (w) w.close();
    throw err;
  }
};

export const undoToast = (msg, undoId, onRestored) => {
  if (!undoId) { toast.success(msg); return; }
  toast.success(msg, {
    duration: 8000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.post(`/undo/${undoId}`);
          toast.success("Restored successfully");
          onRestored?.();
        } catch {
          toast.error("Undo failed");
        }
      },
    },
  });
};
export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—";
export const CATEGORIES = ["Suit", "Garara", "Lehenga", "Dress", "Saree", "Frock", "Others"];
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong";
};
